import { render, staticRenderFns } from "./ChartjsLineChart.vue?vue&type=template&id=be8588fc&"
import script from "./ChartjsLineChart.vue?vue&type=script&lang=js&"
export * from "./ChartjsLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports